const riley = "/_app/immutable/assets/riley.5JiLs8gN.png";
export {
  riley as default
};
